import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { MetricFacade } from '@mode/metrics/domain';

export const DowngradedMetricsDomainModule = angular
  .module('downgraded-metrics-domain', [])
  .service('MetricFacade', downgradeInjectable(MetricFacade)).name;
